import { toVueComponent } from "@scalar-org/vue-render";
import { html } from "../../helpers/html-template.js";
import { EditorClasses } from "../../styles.js";
function pageLinkHtml(props) {
  const linkAttr = "filepath" in props ? `data-scalar-page-link-filepath="${props.filepath}"` : `data-link-id="${props.uid}"`;
  return html`
    <a 
      class="${EditorClasses.PageLink}" 
      ${linkAttr}
      data-scalar-type="page-link"
    >
      <span>${props.title}</span>
      <p>${props.description}</p>
    </a>`;
}
const ScalarPageLinkVue = toVueComponent(
  (props) => pageLinkHtml(props),
  {
    title: String,
    description: String,
    uid: String
  }
);
export {
  ScalarPageLinkVue,
  pageLinkHtml
};
//# sourceMappingURL=component.js.map
